import { Grid, Tooltip, Typography } from "@material-ui/core";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Avatar,
  Box,
  IconButton,
  Link,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import jwt_decode from "jwt-decode";
import React, { useContext, useEffect, useState } from "react";
import { useDymoCheckService, useDymoFetchPrinters } from "react-dymo-hooks";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as ForceCheckOut } from "../../assets/USA_Images/dashboard_icons/Force_Checkout.svg";
import { ReactComponent as PreRegistrationCheckedInIcon } from "../../assets/USA_Images/dashboard_icons/PreRegistrationCheckedInIcon.svg";
import { ReactComponent as Printer } from "../../assets/USA_Images/dashboard_icons/Printer.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import FilterForm from "../../components/DialogBoxComponent/FilterForm";
import FreeTrialDialog from "../../components/DialogBoxComponent/FreeTrialDialog";
import WhatsNewDialog from "../../components/DialogBoxComponent/WhatsNewDialog";
import ProfileContext from "../../components/ProfileContext";
import CustomStyleStatus from "../../components/statusStyleFormat/statusStyleFormat";
import Toast from "../../components/ToastContainer/CustomToast";
import { getListSettingsById } from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import { getAllVisitors } from "../../slices/Approvals/selfRegistarationApprovalSlice";
import { getDashBoardStatics } from "../../slices/DashBoard/DashBoardSlice";
import {
  dymoPrinterForDashboard,
  forceUpdate,
} from "../../slices/PinNumber/PinNumberSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import CustomDateFilter from "../DailyReports/CustomDateFilter";
import DashboardCards from "../DashBoard/DashboardCards";
import GlobalDataContext from "../GlobalDataContext";
import PreRegistrationEditDialog from "../PerRegistration/PreRegistrationEditDialog";
import ManualCheckout from "./ManualCheckout";
import PrinterDialogBox from "./PrinterDialogBox";

const Dymo = require("dymojs"),
  dymo = new Dymo();

function RowActionMenu({ actions, darkMode }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const enabled = actions.length > 0;

  return (
    <>
      <IconButton
        size="small"
        aria-label="more actions"
        aria-haspopup="true"
        disabled={!enabled}
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        sx={{
          width: 30,
          height: 30,
          p: 0,
          flexShrink: 0,
          color: darkMode ? "#fff" : "#474a4e",
          "&.Mui-disabled": {
            color: darkMode ? "#fff" : "#474a4e",
            opacity: 0.35,
          },
        }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        onClick={(event) => event.stopPropagation()}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          style: {
            minWidth: 200,
            backgroundColor: darkMode ? "#0E2A41" : "",
            color: darkMode ? "#fff" : "",
          },
        }}
      >
        {actions.map((action) => (
          <MenuItem
            key={action.label}
            disabled={action.disabled}
            onClick={() => {
              setAnchorEl(null);
              action.onClick();
            }}
            sx={
              darkMode
                ? {
                    color: "#fff",
                    "&.MuiMenuItem-root:hover": {
                      backgroundColor: "rgb(40, 63, 84) !important",
                      color: "#fff",
                    },
                  }
                : undefined
            }
          >
            <ListItemIcon sx={{ minWidth: "36px !important" }}>
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "& svg": {
                    width: 20,
                    height: 20,
                    fill: darkMode ? "#fff" : undefined,
                  },
                }}
              >
                {action.icon}
              </Box>
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{ fontSize: 14, lineHeight: "24px" }}
            >
              {action.label}
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default function Dashboard(props) {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const [todaysStatics, setTodaysStatics] = useState({});
  const [clear, setClear] = useState(false);
  const { t } = useTranslation();
  const [settings, setSettings] = useState();
  const [latestVersion, setLatestVersion] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const { darkMode } = useContext(ThemeContext);
  const [loading, setLoading] = useState(true);
  const { setCompanySettings } = useContext(GlobalDataContext);
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  );
  const isFrontDesk = decoded_jwtToken.roleCode === "FRONTDESK";
  const { visitorEvents, setVisitorEvents } = useContext(ProfileContext);
  const [openExpireDialog, setOpenExpireDialog] = useState(false);
  const [openManualCheckOut, setOpenManualCheckOut] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const [visitorName, setVisitorName] = useState();
  const [forceCheckOutCard, setForceCheckOutCard] = useState(false);
  const statusDymoService = useDymoCheckService();
  const { statusFetchPrinters, printers } = useDymoFetchPrinters(
    statusDymoService,
  );
  const [selectedPrinterData, setSelectedPrinterData] = useState();
  const [preRegistration, setPreRegistration] = useState();
  const [editPreRegistration, setEditPreRegistration] = useState(false);
  const [openPrinter, setOpenPrinter] = useState(false);
  const [labelPrinter, setLabelPrinter] = useState(false);
  const [currentFilter, setCurrentFilter] = useState({
    hostId: "",
    purposeTypeId: "",
    status: [
      "SCHEDULED",
      "CONFIRMED",
      "APPROVED",
      "CHECKED_IN",
      "CHECKED_OUT",
      "CANCELLED",
      "INITIATED_FOR_BLOCKED",
      "BLOCKED",
      "REJECTED",
      "MISSED",
      "COMPLETED",
      "LOGGED",
      "TIME_EXPIRED",
      "PENDING_ARRIVAL",
    ],
    visitMode: [
      "INVITATION",
      "WALKIN_REGISTARTION",
      "SELF_REGISTARTION",
      "WALKIN_REGISTARTION_KIOSK",
      "PRE_REGISTRATION",
    ],
  });
  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };

  var today = new Date();
  var endDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T23:59:59";
  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T00:00";

  const [selectedDates, setSelectedDates] = useState({
    scheduledStartDate: CommonUtil.formatToUtc(startDate),
    scheduledEndDate: CommonUtil.formatToUtc(endDate),
  });

  const defaultFilter = {
    hostId: "",
    purposeTypeId: "",
    status: [
      "SCHEDULED",
      "CONFIRMED",
      "APPROVED",
      "CHECKED_IN",
      "CHECKED_OUT",
      "CANCELLED",
      "INITIATED_FOR_BLOCKED",
      "BLOCKED",
      "REJECTED",
      "MISSED",
      "COMPLETED",
      "LOGGED",
      "TIME_EXPIRED",
      "PENDING_ARRIVAL",
    ],
    hostEmail: "",
    createdBy: "",
    visitMode: [
      "INVITATION",
      "WALKIN_REGISTARTION",
      "SELF_REGISTARTION",
      "WALKIN_REGISTARTION_KIOSK",
      "PRE_REGISTRATION",
    ],
  };

  const [invFilter, setInvFilter] = React.useState({
    hostId: "",
    purposeTypeId: "",
    status: [
      "SCHEDULED",
      "CONFIRMED",
      "APPROVED",
      "CHECKED_IN",
      "CHECKED_OUT",
      "CANCELLED",
      "INITIATED_FOR_BLOCKED",
      "BLOCKED",
      "REJECTED",
      "MISSED",
      "COMPLETED",
      "LOGGED",
      "TIME_EXPIRED",
    ],
    visitMode: ["INVITATION"],
  });

  const [regFilter, setRegFilter] = React.useState({
    hostId: "",
    purposeTypeId: "",
    status: [
      "CHECKED_IN",
      "CHECKED_OUT",
      "CANCELLED",
      "INITIATED_FOR_BLOCKED",
      "BLOCKED",
      "MISSED",
      "COMPLETED",
      "LOGGED",
      "TIME_EXPIRED",
    ],
    visitMode: ["WALKIN_REGISTARTION", "WALKIN_REGISTARTION_KIOSK"],
  });

  const [selfRegFilter, setSelfRegFilter] = React.useState({
    status: [
      "CONFIRMED",
      "APPROVED",
      "CHECKED_IN",
      "CHECKED_OUT",
      "CANCELLED",
      "INITIATED_FOR_BLOCKED",
      "BLOCKED",
      "REJECTED",
      "MISSED",
      "COMPLETED",
      "LOGGED",
      "TIME_EXPIRED",
    ],
    purposeTypeId: "",
    hostId: "",
    visitMode: ["SELF_REGISTARTION"],
  });

  const [preRegistrationFilter, setPreRegistrationFilter] = React.useState({
    status: [
      "PENDING_ARRIVAL",
      "CHECKED_IN",
      "CHECKED_OUT",
      "CANCELLED",
      "INITIATED_FOR_BLOCKED",
      "BLOCKED",
      "REJECTED",
      "MISSED",
      "COMPLETED",
      "TIME_EXPIRED",
    ],
    visitMode: ["PRE_REGISTRATION"],
  });

  const [checkinFilter, setCheckinFilter] = React.useState({
    hostId: "",
    purposeTypeId: "",
    status: ["CHECKED_IN"],
    visitMode: [
      "INVITATION",
      "WALKIN_REGISTARTION",
      "SELF_REGISTARTION",
      "WALKIN_REGISTARTION_KIOSK",
      "PRE_REGISTRATION",
    ],
  });

  const [checkOutFilter, setCheckOutFilter] = React.useState({
    hostId: "",
    purposeTypeId: "",
    status: ["CHECKED_OUT", "COMPLETED"],
    visitMode: [
      "INVITATION",
      "WALKIN_REGISTARTION",
      "SELF_REGISTARTION",
      "WALKIN_REGISTARTION_KIOSK",
      "PRE_REGISTRATION",
    ],
  });
  const [confirmedFilter, setConfirmedFilter] = React.useState({
    hostId: "",
    purposeTypeId: "",
    status: ["CONFIRMED"],
    isPagable: true,
    createdAt: CommonUtil.formatToUtc(startDate),
    visitMode: [
      "INVITATION",
      "WALKIN_REGISTARTION",
      "SELF_REGISTARTION",
      "WALKIN_REGISTARTION_KIOSK",
    ],
  });

  const [notCheckedOutFilter, setNotCheckedOutFilter] = React.useState({
    hostId: "",
    purposeTypeId: "",
    status: ["TIME_EXPIRED"],
    isPagable: true,
    visitMode: [
      "INVITATION",
      "WALKIN_REGISTARTION",
      "SELF_REGISTARTION",
      "WALKIN_REGISTARTION_KIOSK",
      "PRE_REGISTRATION",
    ],
  });

  const print = (data) => {
    if (!Array.isArray(printers) || printers.length === 0) {
      return;
    }
    printers.forEach((printer) => {
      try {
        dymo.print(printer.name, data);
        console.log(`Print job sent to ${printer.name}`);
      } catch (error) {
        console.error(`Print failed for ${printer.name}:`, error);
      }
    });
  };

  const applyFilter = (filterData) => {
    setLoading(true);
    setClear(true);
    const query = {
      purposeTypeId: filterData.purposeTypeId,
      status: filterData.status,
      hostId: filterData.hostId,
      visitMode: [filterData.visitMode],
    };
    setCurrentFilter({
      ...currentFilter,
      ...query,
    });
  };

  const resetFilter = () => {
    setLoading(true);
    setClear(false);
    setCurrentFilter({
      ...defaultFilter,
    });
  };

  const handleChange = (newPage, size) => {
    setLoading(true);
    setPage(newPage);
    forceCheckOutCard
      ? loadHaventCheckedOutData(newPage, size)
      : loadData(newPage, size);
    setRowsPerPage(size);
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  useEffect(() => {
    loadSetting();
  }, []);

  useEffect(() => {
    loadData(1, rowsPerPage);
    loadDashBoard();
  }, [currentFilter, selectedDates]);

  const loadData = (page, rowsPerPage) => {
    const payload = {
      filter: { ...currentFilter, ...selectedDates },
      page: page,
      rowsPerPage: rowsPerPage,
    };

    dispatch(getAllVisitors(Object.assign(payload)))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          setLoading(false);
          setTotalRecords(data.data.totalCount);
          setRows(data.data.visits);
          setPage(data.data.curPage || page || 1);
          setTotalPages(data.data.totalPages);
        } else {
          setRows([]);
        }
      })
      .catch((er) => {});
  };

  const loadHaventCheckedOutData = (page, size) => {
    setLoading(true);
    const payload = {
      filter: { ...notCheckedOutFilter, ...selectedDates },
      page: page,
      rowsPerPage: size,
    };

    dispatch(getAllVisitors(payload))
      .unwrap()
      .then((response) => {
        setLoading(false);

        if (
          response.code !== "CVAI0000" ||
          !response.data ||
          !Array.isArray(response.data.visits)
        ) {
          setRows([]);
          return;
        }

        const now = new Date();

        const expiredVisits = response.data.visits.filter(
          (visit) =>
            visit.finalCheckOutTime && now > new Date(visit.finalCheckOutTime),
        );

        setRows(expiredVisits);
        setTotalRecords(expiredVisits.length);
        setPage(response.data.curPage || 1);
        setTotalPages(response.data.totalPages || 0);
      })
      .catch((error) => {
        console.error(error);

        setLoading(false);
        setRows([]);
        setTotalRecords(0);
        setPage(1);
        setTotalPages(0);
      });
  };

  const loadDashBoard = () => {
    dispatch(getDashBoardStatics(selectedDates))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          setTodaysStatics(data.data);
        } else {
          setTodaysStatics({});
        }
      })
      .catch((er) => {});
  };

  const handleManualCheckOut = (params) => {
    setVisitorName(
      params.visitor.firstName + " " + (params.visitor?.lastName || ""),
    );
    setSelectedData(params);
    setOpenManualCheckOut(!openManualCheckOut);
  };

  const handlePrinter = (params) => {
    setSelectedPrinterData(params);
    setOpenPrinter(!openPrinter);
  };

  const handleDymoPrinterEnable = () => {
    const payload = {
      id: selectedPrinterData.id,
      firstName: selectedPrinterData?.visitor?.firstName,
      lastName: selectedPrinterData?.visitor?.lastName,
      emailId: selectedPrinterData?.visitor?.email,
      phone: selectedPrinterData?.visitor?.phone,
      visitorProfilePhoto: selectedPrinterData?.visitor?.profilePhotoURL,
      status: selectedPrinterData.status,
    };

    dispatch(dymoPrinterForDashboard(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4111") {
          Toast(res.message, "success");

          if (settings?.badgePrint) {
            print(res.data.dymoLabel);
          }

          // Correct: call the setter
          setOpenPrinter(false);

          loadDashBoard();
        } else {
          Toast(res.message, "error");
        }
      })
      .catch((error) => {
        Toast(error?.message || "Something went wrong.", "error");
      });
  };

  const handlestatusUpdate = () => {
    let payload = {
      id: selectedData.id,
      name: selectedData.visitor?.lastName
        ? selectedData.visitor?.firstName + " " + selectedData.visitor?.lastName
        : selectedData.visitor?.firstName,
    };
    dispatch(forceUpdate(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4054") {
          Toast(res.message, "success");
          setOpenManualCheckOut(!openManualCheckOut);
          loadDashBoard();
          forceCheckOutCard
            ? loadHaventCheckedOutData(1, rowsPerPage)
            : loadData(1, rowsPerPage);
          return;
        } else {
          Toast(res.message, "error");
          return;
        }
      });
  };

  const loadSetting = () => {
    dispatch(getListSettingsById(decoded_jwtToken.companyId))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setSettings(data.data);
          setCompanySettings(data.data);
          localStorage.setItem("companySettings", JSON.stringify(data.data));
          setVisitorEvents(data.data.autoCheckOut);
          setLatestVersion(data.data.latestVersion);
          setLabelPrinter(data.data?.badgePrint);
          if (data.data.viewedVersion === data.data.latestVersion)
            setShowPopup(false);
          else setShowPopup(true);
        }
      });
  };

  const handlePreRegistrationEdit = (params) => {
    setPreRegistration(params);
    setEditPreRegistration(true);
  };

  const handalCardChange = (params) => {
    if (params === "Checkin") {
      setCurrentFilter({ ...currentFilter, ...checkinFilter });
      setForceCheckOutCard(false);
    }
    if (params === "checkOut") {
      setCurrentFilter({ ...currentFilter, ...checkOutFilter });
      setForceCheckOutCard(false);
    }
    if (params === "registration") {
      setCurrentFilter({ ...currentFilter, ...regFilter });
      setForceCheckOutCard(false);
    }
    if (params === "Invitation") {
      setCurrentFilter({ ...currentFilter, ...invFilter });
      setForceCheckOutCard(false);
    }
    if (params === "confirmed") {
      setCurrentFilter({ ...currentFilter, ...confirmedFilter });
      setForceCheckOutCard(false);
    }
    if (params === "selfRegistration") {
      setCurrentFilter({ ...currentFilter, ...selfRegFilter });
      setForceCheckOutCard(false);
    }
    if (params === "notCheckedOut") {
      setPage(1);
      loadHaventCheckedOutData(1, rowsPerPage);
      setForceCheckOutCard(true);
    }
    if (params === "preRegistration") {
      setCurrentFilter({ ...currentFilter, ...preRegistrationFilter });
      setForceCheckOutCard(false);
    }
  };

  const handleDatePickerFilter = (sdate, edate) => {
    setLoading(true);
    setSelectedDates({
      scheduledStartDate: CommonUtil.formatToUtc(sdate),
      scheduledEndDate: CommonUtil.formatToUtc(edate),
    });
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 20) {
      return text.substring(0, 20) + "...";
    } else {
      return text;
    }
  };

  const isForceCheckoutEnabled = (row) => {
    const nowUTC = new Date().getTime();
    const finalUTC = new Date(row.finalCheckOutTime + "Z").getTime();
    return nowUTC > finalUTC && row.status === "TIME_EXPIRED";
  };

  const isPrintEnabled = (row) => {
    return row.status === "CHECKED_IN";
  };

  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { firstName, lastName, profilePhotoURL } = params.row.visitor;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };
    // Get initials
    const initials = `${firstName?.charAt(0) || ""}${lastName?.charAt(0) ||
      ""}`;
    const bgColor = !profilePhotoURL ? getAvatarColor(initials) : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = profilePhotoURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };
  const columns = React.useMemo(() => [
    {
      field: "visitor.profile",
      headerName: "",
      sortable: false,
      width: 10,
      renderCell: (params) => {
        return ZoomHandaler(params);
      },
    },
    {
      field: "visitor.firstName",
      headerName: t("COMMON014"),
      flex: 1.2,
      minWidth: 130,
      valueGetter: (params) =>
        params.row.visitor.lastName !== null
          ? params.row.visitor.firstName + " " + params.row.visitor.lastName
          : params.row.visitor.firstName,
      renderCell: (params) => (
        <Tooltip
          title={` ${
            params.row.visitor.lastName !== null
              ? params.row.visitor.firstName + " " + params.row.visitor.lastName
              : params.row.visitor.firstName
          }`}
          placement="bottom-start"
        >
          <span>
            {handleTextOverflow(
              params.row.visitor.lastName !== null
                ? params.row.visitor.firstName +
                    " " +
                    params.row.visitor.lastName
                : params.row.visitor.firstName,
            )}
          </span>
        </Tooltip>
      ),
    },

    {
      field: "visitor.phone",
      headerName: t("COMMON063"),
      type: "singleSelect",
      flex: 1,
      minWidth: 110,
      valueGetter: (params) => params.row.visitor.phone,
    },
    {
      field: "visitor.email",
      headerName: t("PERSON005"),
      flex: 1.3,
      minWidth: 130,
      valueGetter: (params) => params.row.visitor.email,
    },
    {
      field: "hostName",
      headerName: t("commonsTextFeildHostValue"),
      flex: 1,
      minWidth: 110,
      valueGetter: (params) => params.row.hostName,
    },
    {
      field: "purpose",
      headerName: t("Purpose"),
      flex: 1,
      minWidth: 110,
      valueGetter: (params) =>
        params.row.visitor.purposeType !== null
          ? params.row.purposeType?.name
          : "",
    },

    {
      field: "status",
      headerName: t("COMMON001"),
      flex: 1.2,
      minWidth: 210,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <CustomStyleStatus
          row={params.row.status}
          visitMode={params.row.visitMode}
          darkMode={darkMode}
          icon={true}
        />
      ),
    },
    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      width: 90,
      align: "center",
      headerAlign: "center",
      getActions: (params) => [
        <RowActionMenu
          key={params.row.id}
          darkMode={darkMode}
          actions={[
            !visitorEvents && {
              label: "Check Out",
              icon: <ForceCheckOut />,
              disabled: !isForceCheckoutEnabled(params.row),
              onClick: () => handleManualCheckOut(params.row),
            },
            labelPrinter && {
              label: "Badge Print",
              icon: <Printer />,
              disabled: !isPrintEnabled(params.row),
              onClick: () => handlePrinter(params.row),
            },
            isFrontDesk &&
              params.row.visitMode === "PRE_REGISTRATION" &&
              params.row.status === "PENDING_ARRIVAL" && {
                label: t("EDIT_PRE_REGISTRATION"),
                icon: <PreRegistrationCheckedInIcon />,
                onClick: () => handlePreRegistrationEdit(params.row),
              },
          ].filter(Boolean)}
        />,
      ],
    },
  ]);

  const status = [
    "SCHEDULED",
    "CONFIRMED",
    "PENDING_ARRIVAL",
    "APPROVED",
    "TIME_EXPIRED",
    "CHECKED_IN",
    "CHECKED_OUT",
    "CANCELLED",
    "INITIATED_FOR_BLOCKED",
    "BLOCKED",
    "REJECTED",
    "MISSED",
    "LOGGED",
    "COMPLETED",
  ];

  return (
    <Grid container spacing={3}>
      <Grid
        item
        style={{
          paddingLeft: "14px",
        }}
      >
        <Typography
          variant="h3"
          style={{
            color: darkMode ? "#fff" : "#3D4977",
          }}
        >
          {t("labelNavItemsDashboard")}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sm={12}
        style={{
          padding: "0px",
          paddingLeft: "6px",
          paddingTop: "6px",
          paddingRight: "6px",
        }}
      >
        <DashboardCards
          getRowData={(params) => handalCardChange(params)}
          data={todaysStatics}
          // havenotCheckedOut={loadHaventCheckedOutData}
        />
      </Grid>
      <Grid
        container
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          width: "100%",
          gap: "16px",
          paddingRight: "13px",
        }}
      >
        <Grid item>
          <CustomDateFilter
            datePickerFilter={(sdate, edate) =>
              handleDatePickerFilter(sdate, edate)
            }
          />
        </Grid>
        <Grid item>
          <FilterForm
            rowsPerPage={rowsPerPage}
            selectedObject={currentFilter.visitMode}
            status={status}
            applyFilter={(data) => applyFilter(data)}
          />
        </Grid>
        {clear && (
          <Grid
            item
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          </Grid>
        )}
      </Grid>
      <Grid item xs={12} style={{ marginTop: "6px", paddingRight: "13px" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          dashboard={true}
          page={page}
          count={totalRecords}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </Grid>
      {openExpireDialog ? (
        <FreeTrialDialog fullWidth={true} open={openExpireDialog} />
      ) : (
        ""
      )}

      {showPopup && (
        <WhatsNewDialog
          open={showPopup}
          Header={t("CUSTDATABLE34")}
          onClose={() => {
            setShowPopup(!showPopup);
          }}
          latestVersion={latestVersion}
          settings={settings}
        />
      )}

      {openManualCheckOut && (
        <ManualCheckout
          onClose={() => {
            setOpenManualCheckOut(!openManualCheckOut);
            loadData(1, rowsPerPage);
          }}
          onSubmit={handlestatusUpdate}
          open={openManualCheckOut}
          visitorName={visitorName}
        />
      )}
      {openPrinter && (
        <PrinterDialogBox
          onClose={() => {
            setOpenPrinter(false);
            loadData(1, rowsPerPage);
          }}
          onSubmit={handleDymoPrinterEnable}
          open={openPrinter}
          visitorName={visitorName}
        />
      )}
      {editPreRegistration && (
        <PreRegistrationEditDialog
          open={editPreRegistration}
          rowData={preRegistration}
          showDLScan={true}
          walkImageCaptureLimit={settings?.walkInImagesCaptureLimit}
          onClose={() => {
            setEditPreRegistration(false);
            setPreRegistration(undefined);
          }}
          onSaved={() => {
            loadData(page, rowsPerPage);
            loadDashBoard();
          }}
        />
      )}
    </Grid>
  );
}
